import { OnboardingAdmin, OnboardingStatus2 } from "../lib/ShiOneClient";

export const getWelcomeProgressLocalStorage = (): OnboardingStatus2 => {
  const onboardingStatusString = localStorage.getItem("onboardingStatus");
  if (onboardingStatusString != null) {
    return JSON.parse(onboardingStatusString) as OnboardingStatus2;
  }
  return new OnboardingStatus2({
    accountId: -1,
    accountName: "",
    contactCreationSuccessful: false,
    welcomeLinkGuid: "",
    connections: [],
    domains: [],
    existingAdmins: [],
    firstAdmin: {} as OnboardingAdmin,
  });
};

export const setWelcomeProgressLocalStorage = (
  welcomeProgress: OnboardingStatus2
) => {
  localStorage.setItem("onboardingStatus", JSON.stringify(welcomeProgress));
};
